import { postQueries } from "@circle-react/lib/queries/posts";
import type { ContentReactionType } from "@circle-react/types/ContentReaction";
import type { Post } from "@circle-react/types/Post";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

export const usePostLikes = (
  post: Post,
  reactionType?: ContentReactionType | null,
) => {
  const { data, isInitialLoading, fetchNextPage, hasNextPage } =
    useInfiniteQuery(postQueries.postLikes({ postId: post.id, reactionType }));

  const members = useMemo(
    () => data?.pages.flatMap(page => page.records) ?? [],
    [data],
  );
  const totalCount = data?.pages[0]?.count ?? post.user_likes_count;
  return {
    members,
    totalCount,
    isInitialLoading,
    fetchNextPage,
    hasNextPage,
  };
};
